import Vue from "vue";
import Main from './Main.vue'

Vue.mixin({
  methods: {
  }
})
new Vue({
  render: h => h(Main)
}).$mount("#app");
